import { render, staticRenderFns } from "./pro-chiose-tab-member.vue?vue&type=template&id=418fd849&scoped=true";
import script from "./pro-chiose-tab-member.vue?vue&type=script&lang=jsx";
export * from "./pro-chiose-tab-member.vue?vue&type=script&lang=jsx";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "418fd849", null);
export default component.exports;